import { Component, inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Select, Store } from '@ngxs/store';
import { InitForgotPasswordRequest } from '../../state/auth.actions';
import { AuthState } from '../../state/auth.state';
import { PasswordRequestState } from '../../state/auth.model';
import { Observable } from 'rxjs';
import { FlexFillDirective, LayoutDirective, LayoutAlignDirective } from '@ngbracket/ngx-layout/flex';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatToolbar } from '@angular/material/toolbar';
import { CdkTrapFocus } from '@angular/cdk/a11y';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'dash-gis-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    imports: [
        FlexFillDirective,
        LayoutDirective,
        LayoutAlignDirective,
        MatCard,
        MatToolbar,
        MatCardContent,
        CdkTrapFocus,
        FormsModule,
        ReactiveFormsModule,
        MatFormField,
        MatLabel,
        MatInput,
        MatButton,
        AsyncPipe,
    ],
})
export class ForgotPasswordComponent implements OnInit {
    requestState$: Observable<PasswordRequestState> = inject(Store).select(AuthState.forgotPasswordRequestState);

    forgotPasswordForm: UntypedFormGroup;

    constructor(private store: Store, private fb: UntypedFormBuilder) {
        this.forgotPasswordForm = fb.group({
            identifier: ['', Validators.required],
        });
    }

    ngOnInit(): void {}

    beginPasswordReset() {
        const identifier = this.forgotPasswordForm.get('identifier').value;
        this.store.dispatch(new InitForgotPasswordRequest(identifier));
    }
}
